var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { TableCell } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getSalesRepBaseData } from "../../reduxStore/actions/salesRepDataAction";
import { isLoading } from "../../services/behaviorSubjectService";
import { addNewSalesRep, repOrderDetails, checkCanCreateRepService } from "../../services/apiServices/salesRepDataService";
import store from "../../reduxStore/store";
import { isNullOrEmpty } from "../../shared/Utilites";
import { regexEmailValidation } from "../../shared/regex";
export var TeamsBL = function () {
    var _a, _b, _c;
    var repDetails = useSelector(function (state) { return state.salesRepData; });
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _d = useState(), orderRows = _d[0], setOrderRows = _d[1];
    var teamDetails = (_a = repDetails === null || repDetails === void 0 ? void 0 : repDetails.baseData) === null || _a === void 0 ? void 0 : _a.teammemberdetails;
    var Names = teamDetails === null || teamDetails === void 0 ? void 0 : teamDetails.map(function (team) { return team.Name; });
    var shopCurrency = store.getState().salesRepData.loggedInRepDetails.shopCurrency;
    var currency = store.getState().salesRepData.loggedInRepDetails.currency;
    var _e = useState(""), rep = _e[0], setRep = _e[1];
    var _f = useState(false), loadingBtn = _f[0], setLoadingBtn = _f[1];
    var _g = useState(false), successMsg = _g[0], setSuccessMsg = _g[1];
    var _h = useState(false), failureMsg = _h[0], setFailureMsg = _h[1];
    var _j = useState(false), loadingDisabled = _j[0], setLoadingDisabled = _j[1];
    var _k = useState(false), addRep = _k[0], setAddRep = _k[1];
    var _l = useState(""), seatLimitMsg = _l[0], setSeatLimitMsg = _l[1];
    var _m = useState(false), checkingRepLimit = _m[0], setCheckingRepLimit = _m[1];
    var _o = useState({ repFirstName: "", repEmail: "", repLastName: "" }), newRepForm = _o[0], setNewRepForm = _o[1];
    var _p = useState({ firstName: false, email: false, lastName: false }), isError = _p[0], setError = _p[1];
    var regexEmail = regexEmailValidation;
    var regexName = /^[a-zA-Z\s]*$/;
    var shopName = (_b = repDetails === null || repDetails === void 0 ? void 0 : repDetails.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.shopName;
    var queryString = repDetails.baseData.SingleSalesRep !== undefined &&
        repDetails.baseData.SingleSalesRep !== null &&
        repDetails.baseData.SingleSalesRep.SalesRepAffiliateUrl !== undefined &&
        repDetails.baseData.SingleSalesRep.SalesRepAffiliateUrl !== null
        ? (_c = repDetails.baseData.SingleSalesRep.SalesRepAffiliateUrl) === null || _c === void 0 ? void 0 : _c.split("?")[1]
        : "ambassador=";
    var urlParams = new URLSearchParams(queryString);
    var ambassador = urlParams.get("ambassador");
    var signupUrl = "https://" + shopName + "/pages/sales-representative-sign-up?manager=" + ambassador;
    var showRepForm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSeatLimitMsg("");
                    setCheckingRepLimit(true);
                    return [4 /*yield*/, checkCanCreateRepService()];
                case 1:
                    result = _a.sent();
                    setCheckingRepLimit(false);
                    if ((result === null || result === void 0 ? void 0 : result.canCreateRep) === false) {
                        setSeatLimitMsg(result.message);
                    }
                    setAddRep(true);
                    return [2 /*return*/];
            }
        });
    }); };
    isLoading.subscribe(function (data) {
        if (data !== loadingDisabled)
            setLoadingDisabled(data);
    });
    var orderTableColumns = [
        {
            id: "order_number",
            label: t("team_column1"),
        },
        {
            id: "order_date",
            label: t("team_column2"),
        },
        {
            id: "customer_name",
            label: t("team_column3"),
        },
        {
            id: "sub_total",
            label: t("team_column5"),
        },
        {
            id: "sales_rep_commission",
            label: t("team_column6"),
        },
        {
            id: "team_manager_commission",
            label: t("team_column7"),
        },
        {
            id: "commission_type",
            label: t("team_column8"),
        },
    ];
    var createHeaders = function (col) {
        return col === null || col === void 0 ? void 0 : col.map(function (item, index) { return (_jsx(TableCell, __assign({ align: "center", className: "ST_CommonSubheading_Font_size" }, { children: _jsx("b", { children: item.label }) }), index)); });
    };
    function openRepDropDown(event) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var members, data, commissions, AllOrdersCommission, currentManagerId_1, selectedRepId_1, filteredOrders, data_1, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 4, 5, 6]);
                        setRep(event.target.value);
                        if (!(event.target.value !== "None" && event.target.value !== "" && event.target.value !== null)) return [3 /*break*/, 2];
                        members = teamDetails === null || teamDetails === void 0 ? void 0 : teamDetails.filter(function (member) { return member.Name === event.target.value; });
                        data = { repName: event.target.value, repId: members[0].Id };
                        isLoading.next(true);
                        return [4 /*yield*/, repOrderDetails(data)];
                    case 1:
                        commissions = _d.sent();
                        if (commissions) {
                            AllOrdersCommission = commissions.AllOrdersCommission;
                            currentManagerId_1 = ((_a = repDetails === null || repDetails === void 0 ? void 0 : repDetails.loggedInRepDetails) === null || _a === void 0 ? void 0 : _a.customerId) || ((_b = repDetails === null || repDetails === void 0 ? void 0 : repDetails.loggedInRepDetails) === null || _b === void 0 ? void 0 : _b.CustomerId);
                            selectedRepId_1 = (_c = members[0]) === null || _c === void 0 ? void 0 : _c.Id;
                            filteredOrders = AllOrdersCommission === null || AllOrdersCommission === void 0 ? void 0 : AllOrdersCommission.filter(function (order) {
                                // Check if the order has manager information that matches the current manager
                                var orderManagerId = order.TeamManagerId;
                                var orderRepId = order.SalesRepId;
                                // Show order if:
                                // 1. The order's manager ID matches the current manager ID, OR
                                // 2. The order's rep ID matches the selected rep ID (for direct rep orders)
                                return (orderManagerId && String(orderManagerId) === String(currentManagerId_1)) || (orderRepId && String(orderRepId) === String(selectedRepId_1));
                            });
                            data_1 = filteredOrders === null || filteredOrders === void 0 ? void 0 : filteredOrders.map(function (order) {
                                var orderObject = {};
                                Object.assign(orderObject, {
                                    orderNumber: order.orderNumber,
                                    orderDate: order.orderDate,
                                    orderName: order.orderName,
                                    CustomerName: order.CustomerName,
                                    subtotal: order.subtotal,
                                    commission: order.commission,
                                    TeamManagerCommission: order.TeamManagerCommission,
                                    CommissionType: order.CommissionType,
                                });
                                return orderObject;
                            });
                            setOrderRows(data_1);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        setRep(event.target.value);
                        setOrderRows(null);
                        _d.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _d.sent();
                        console.error("Error in openRepDropDown:", error_1);
                        // Reset states on error to prevent inconsistent UI state
                        setRep("");
                        setOrderRows(null);
                        return [3 /*break*/, 6];
                    case 5:
                        isLoading.next(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    function sendRepInvite() {
        return __awaiter(this, void 0, void 0, function () {
            var data, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoadingBtn(true);
                        setError(__assign(__assign({}, isError), { email: false }));
                        if (!!isNullOrEmpty(newRepForm.repFirstName, newRepForm.repEmail)) return [3 /*break*/, 2];
                        data = {
                            firstName: newRepForm.repFirstName,
                            lastName: newRepForm.repLastName,
                            email: newRepForm.repEmail,
                        };
                        return [4 /*yield*/, addNewSalesRep(data)];
                    case 1:
                        response = _a.sent();
                        if (response === true || (response.StatusCode !== undefined && response.StatusCode !== null && response.StatusCode === 200)) {
                            dispatch(getSalesRepBaseData());
                            setLoadingBtn(false);
                            setSuccessMsg(true);
                            setNewRepForm({ repFirstName: "", repEmail: "", repLastName: "" });
                        }
                        else {
                            setLoadingBtn(false);
                            setFailureMsg(true);
                        }
                        setTimeout(function () {
                            setAddRep(false);
                            setSuccessMsg(false);
                            setFailureMsg(false);
                            setNewRepForm({ repFirstName: "", repEmail: "", repLastName: "" });
                        }, 8000);
                        return [3 /*break*/, 3];
                    case 2:
                        setError(__assign(__assign({}, isError), { email: true }));
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var saveRepInvite = !isNullOrEmpty(newRepForm.repFirstName, newRepForm.repEmail) && newRepForm.repEmail.match(regexEmail) && !(newRepForm.repEmail.indexOf(" ") >= 0) ? false : true;
    function inputChange(e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        if (e.target.name === "repEmail") {
            e.target.value.match(regexEmail) ? setError(__assign(__assign({}, isError), { email: false })) : setError(__assign(__assign({}, isError), { email: true }));
        }
        else if (e.target.name === "repFirstName") {
            regexName.test(e.target.value) ? setError(__assign(__assign({}, isError), { firstName: false })) : setError(__assign(__assign({}, isError), { firstName: true }));
        }
        setNewRepForm(__assign(__assign({}, newRepForm), (_a = {}, _a[name] = value, _a)));
    }
    return {
        saveRepInvite: saveRepInvite,
        shopCurrency: shopCurrency,
        currency: currency,
        rep: rep,
        openRepDropDown: openRepDropDown,
        sendRepInvite: sendRepInvite,
        createHeaders: createHeaders,
        orderRows: orderRows,
        orderTableColumns: orderTableColumns,
        showRepForm: showRepForm,
        checkingRepLimit: checkingRepLimit,
        seatLimitMsg: seatLimitMsg,
        newRepForm: newRepForm,
        inputChange: inputChange,
        signupUrl: signupUrl,
        Names: Names,
        loadingBtn: loadingBtn,
        isError: isError,
        successMsg: successMsg,
        failureMsg: failureMsg,
        addRep: addRep,
        setAddRep: setAddRep,
    };
};
